import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    aria: ownProps.aria,
    type: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id - 1].type,
    // orientation: ownProps.orientation,
    onShelf: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id - 1].onShelf,
    held: state.notebook.protocolSection.scene.apparatus.agaroseGel[ownProps.id - 1].held,
    materialsView: ownProps.materialsView,
  }
}

function mapDispatchToProps(dispatch) {

  return {};
}
export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);